import React from "react";
import { CURRENCY } from "src/config";

// currency obj ref site : https://www.eurochange.co.uk/travel/tips/world-currency-abbreviations-symbols-and-codes-travel-money

const obj = {
  USD: "USDC",
  EUR: "USDC",
  GBP: "USDC",
  CNY: "USDC",
  EGP: "USDC",
  INR: "USDC",
  JPY: "USDC",
};

export const Currency = ({ children }) => {
  const symbol = obj[CURRENCY];

  return (
    <>
      {symbol} {children}
    </>
  );
};
